import React, { useState } from "react";
import { Dialog, InputAdornment, TextField } from "@material-ui/core";
import InfiniteScroll from "react-infinite-scroller";
import { P_Props } from "./FaqListing.type";
import { FloatingButton, Loading, Notification, Pulse, CustomButton } from "../../components";
import { TEXT } from "../../../constants";
import { PriorityHigh as PriorityHighIcon, Search } from "@material-ui/icons";
import { EditIcon, DeleteIcon, PostSubIcon } from "../../icons";
import FaqForm from "../FaqForm";

const FaqListingPresenter: React.FC<P_Props> = (props) => {
  const [visibleFloatingBtn, setVisibleFloatingBtn] = useState<boolean>(false);
  const [visibleDeleteFaqModal, setVisibleDeleteFaqModal] = React.useState<{
    visible: boolean;
    id: string | null;
    title: string | null;
  }>({ visible: false, id: null, title: null });

  const toggleDeleteFaqModal = (id?: string, title?: string) => {
    id && title
      ? setVisibleDeleteFaqModal({ visible: true, id, title })
      : setVisibleDeleteFaqModal({ visible: false, id: null, title: null });
  };

  const toggleFloatingBtn = () => {
    setVisibleFloatingBtn(!visibleFloatingBtn);
  };

  return (
    <>
      <div className="faq-listing">
        <div
          className="faq-listing__content"
          style={{
            opacity: visibleFloatingBtn ? "0.25" : "1",
            pointerEvents: visibleFloatingBtn ? "none" : "auto",
          }}
        >
          <div className="faq-listing__content__header">
            <div className="faq-listing__content__header__title">All FAQ</div>
            <div className="faq-listing__content__header__actions">
              <TextField
                placeholder="Search by question"
                variant="outlined"
                className="search-input"
                inputProps={{ className: "input" }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search className="icon" />
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => {
                  props.onSearch(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="faq-listing__content__list">
            <div className="faq-listing__content__list__header">
              <div className="text faq-listing__content__list__index">Order no.</div>
              <div className="text faq-listing__content__list__title">Question</div>
              <div className="text faq-listing__content__list__author">Answer</div>
              <div className="text faq-listing__content__list__control"></div>
            </div>
            <InfiniteScroll
              useWindow={false}
              pageStart={1}
              initialLoad={false}
              hasMore={!props.fetchedFaq.loading && props.fetchedFaq.totalPages > props.fetchedFaq.page}
              loadMore={() => {
                props.onLoadMore();
              }}
            >
              {!Boolean(props.fetchedFaq.data.length) && props.fetchedFaq.loading && <Loading />}
              {props.fetchedFaq.data.map((faq, index) => {
                return (
                  <div key={faq.id} className="faq-listing__content__list__item">
                    <div className="faq-text faq-listing__content__list__index">{index + 1}</div>
                    <div
                      className="faq-text faq-listing__content__list__title"
                      onClick={() => {
                        props.openFaqFormModal(faq.id);
                      }}
                    >
                      {faq.question || TEXT.EMPTY}
                    </div>
                    <div className="faq-text faq-listing__content__list__author">{faq.answer || TEXT.EMPTY}</div>
                    <div className="faq-text faq-listing__content__list__control">
                      <CustomButton
                        onClick={(e) => {
                          e.stopPropagation();
                          props.openFaqFormModal(faq.id);
                        }}
                        color={"transparent"}
                        item={
                          <span>
                            <EditIcon size={[20, 20]} viewBox={[20, 20]} color={"#272B2F"} />
                          </span>
                        }
                      />
                      <CustomButton
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleDeleteFaqModal(faq.id, faq.question);
                        }}
                        color={"transparent"}
                        item={
                          <span>
                            <DeleteIcon size={[20, 20]} viewBox={[20, 20]} color={"#272B2F"} />
                          </span>
                        }
                      />
                    </div>
                  </div>
                );
              })}
              {Boolean(props.fetchedFaq.data.length) && props.fetchedFaq.loading && <Loading />}
            </InfiniteScroll>
          </div>
        </div>
      </div>
      <FloatingButton
        visible={visibleFloatingBtn}
        onClickPrimary={() => toggleFloatingBtn()}
        btns={[
          {
            color: "orange",
            title: "FAQ",
            icon: <PostSubIcon size={[24, 24]} color="white" />,
            onClick: (e) => {
              props.openFaqFormModal();
            },
          },
        ]}
      />

      <Dialog fullScreen open={props.visibleFaqForm}>
        <FaqForm
          faqCode={props.visibleFaqId}
          onCancel={() => {
            props.closeFaqFormModal();
          }}
          onComplete_Create={() => {
            props.closeFaqFormModal();
            props.reloadListingPage();
            toggleFloatingBtn();
          }}
          onComplete_Update={() => {
            props.closeFaqFormModal();
            props.reloadListingPage();
          }}
          onComplete_Delete={() => {
            props.closeFaqFormModal();
            props.reloadListingPage();
          }}
        />
      </Dialog>

      <Notification
        visible={visibleDeleteFaqModal.visible}
        title="Delete FAQ"
        subTitle={`Are you sure you want to delete "${visibleDeleteFaqModal.title}" FAQ? This action cannot be undone`}
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="faq-form__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteFaqModal();
              }}
            >
              Cancel
            </button>
            <button
              className="faq-form__delete-modal__actions__confirm"
              onClick={() => {
                const idToDelete = visibleDeleteFaqModal.id;
                toggleDeleteFaqModal();
                if (idToDelete) {
                  props.onDeleteFaq(idToDelete);
                }
              }}
            >
              Confirm
            </button>
          </>
        }
      />
    </>
  );
};

export default FaqListingPresenter;
